import { createContext } from 'react';

// Route names of the bottom bar's pages, set by the app shell (AuthenticatedAppStack).
// Screen treats them as equal top-level pages: no Back button when opened from Home or the bar.
export const TabPagesContext = createContext(new Set());
